
import React from 'react';
import createInlineStyleButton from './util/createInlineStyleButton';

export default createInlineStyleButton({
  style: 'BOLD',
  children: (
    <i className={"fa fa-bold"} aria-hidden="true"></i>
  ),
});
